import angular from 'angular';
import { EditDivisionPayoutPolicyComponent } from './edit-payout-policy/edit-division-payout-policy.component';
import { EditIcdCorporationPayoutPolicyModalComponent } from './edit-payout-policy/edit-icd-corporation-payout-policy-modal.component';
import { EditPayoutPolicyHistoryComponent } from './edit-payout-policy/edit-payout-policy-history.component';
import { EditRogersPayoutPolicyComponent } from './edit-rogers-payout-policy/edit-rogers-payout-policy.component';
import { EditIcdPayoutPolicyComponent } from './icd-payout-policy-list/edit-icd-payout-policy-list.component';
import { IcdPayoutPolicyListContainerComponent } from './icd-payout-policy-list/icd-payout-policy-list-container.component';
import { DivisionPayoutPolicyListComponent } from './payout-policy-list/division-payout-policy-list.component';
import { IcdCorporationPayoutPolicyListComponent } from './icd-payout-policy-list/icd-corporation-payout-policy-list.component';
import { PayoutPolicyListContainerComponent } from './payout-policy-list/payout-policy-list-container.component';

export const PayoutPolicyModule = angular
    .module("apex.mainApp.payout.policy", [])
    .component("apexEditDivisionPayoutPolicy", EditDivisionPayoutPolicyComponent)
    .component("apexEditIcdCorporationPayoutPolicyModal", EditIcdCorporationPayoutPolicyModalComponent)
    .component("apexEditPayoutPolicyHistory", EditPayoutPolicyHistoryComponent)
    .component("apexEditRogersPayoutPolicy", EditRogersPayoutPolicyComponent)
    .component("apexEditIcdPayoutPolicy", EditIcdPayoutPolicyComponent)
    .component("apexIcdPayoutPolicyListContainer", IcdPayoutPolicyListContainerComponent)
    .component("apexDivisionPayoutPolicyList", DivisionPayoutPolicyListComponent)
    .component("apexIcdCorporationPayoutPolicyList", IcdCorporationPayoutPolicyListComponent)
    .component("apexPayoutPolicyListContainer", PayoutPolicyListContainerComponent)
    .name;
